module.exports = __webpack_public_path__ + "static/media/invoice.3469d103.svg";